import { render, staticRenderFns } from "./asn.vue?vue&type=template&id=2bbcf0f4&scoped=true&"
import script from "./asn.vue?vue&type=script&lang=js&"
export * from "./asn.vue?vue&type=script&lang=js&"
import style0 from "./asn.vue?vue&type=style&index=0&id=2bbcf0f4&scoped=true&lang=css&"
import style1 from "./asn.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbcf0f4",
  null
  
)

export default component.exports